export default __webpack_public_path__ + "static/media/bird_pilat.d184ca48.jpg";